<template>
  <div :key="key_page" class="">
    <New3D
      :stone_id="parseInt(id)"
      v-show="new_3d_is_visible"
      @close-modal="new_3d_is_visible = !new_3d_is_visible"
      @create-3d="handleCreate3D"
    />
    <Delete3D
      :stone_id="parseInt(id)"
      :name="stoneDetail.name_material"
      v-show="delete_3d_is_visible"
      @close="delete_3d_is_visible = !delete_3d_is_visible"
      @deleted="handleDelete3D"
    />
    <DeleteImg3D
      :stone_id="parseInt(id)"
      :name="stoneDetail.name_material"
      v-show="delete_img_is_visible"
      @close="delete_img_is_visible = !delete_img_is_visible"
      @deleted="handleDeleteImg"
    />
    <DeleteStone
      :stone_id="parseInt(id)"
      :name="stoneDetail.name"
      v-show="delete_stone_is_visible"
      @close="delete_stone_is_visible = !delete_stone_is_visible"
      @deleted="backPage"
    />

    <EditeStone
      v-show="edit_stone_visible"
      @close-modal="edit_stone_visible = !edit_stone_visible"
      :stone="stoneDetail"
      @edited="handleEdite"
    />

    <div
      class="d-flex flex-row justify-content-between align-itens-center mb-4"
    >
      <div class="d-flex align-items-center text-truncate w-100">
        <router-link :to="{ name: 'StoneList' }">
          <button class="btn p-0">
            <i class="icon icon-arrow-back"></i>
          </button>
        </router-link>
        <h2 class="ml-3">
          {{dataStoneLocale.title}} (n° {{ stoneDetail.bloc_number }})
          {{ stoneDetail.name_material }}
        </h2>
      </div>
      <div v-show="isAdmin2Stone">
        <button
          @click.prevent="delete_stone_is_visible = !delete_stone_is_visible"
          class="btn btn-outline-danger"
        >
          {{is_pt_br ? 'Excluir' : 'Delete'}}
        </button>
      </div>
    </div>
    <div class="row mb-5" :key="key_iframe">
      <div class="col-md-5 col-12">
        <CarrocelImage
          :images="stoneDetail ? stoneDetail.images : []"
        />
      </div>
      <div class="col-md-7 col-12">
        <div class="row">
          <section class="col-12 bg-white divider-bottom rounded p-3 mb-3">
            <h5 class="d-flex justify-content-between">
              {{dataStoneLocale.data_specs.title}}:
              <button
                v-show="isAdmin2Stone"
                class="btn"
                @click="edit_stone_visible = true"
              >
                <i class="icon icon-edite"></i>
              </button>
            </h5>
            <div v-for="(info ,i) in dataStoneLocale.data_specs.list" :key="i">
              <strong>{{info.label}}:</strong>
              <span class="ml-3">{{ stoneDetail[info.entity] }} {{ info.unit_small}}</span>
            </div>
          </section>
          <section
            v-show="isAdmin2Stone"
            class="col-12 bg-white divider-bottom rounded p-3 mb-3"
          >
            <h5 class="d-flex justify-content-between">
              {{dataStoneLocale.data_media.title}}:
              <button
                v-show="isAdmin2Stone && stoneDetail.length_img_3d > 0"
                class="btn"
                @click="delete_img_is_visible = !delete_img_is_visible"
              >
                <i class="icon icon-delete-outlined"></i>
              </button>
            </h5>
            <div v-for="(info ,i) in dataStoneLocale.data_media.list" :key="i">
              <strong>{{info.label}}:</strong>
              <span class="ml-3">
                {{ stoneDetail[info.entity]}}
              </span>
            </div>
          </section>
          <section
            v-show="isAdmin2Stone"
            class="col-12 bg-white divider-bottom rounded p-3 mb-3"
          >
            <h5 class="d-flex justify-content-between">
              3D:
              <div>
                <button
                  v-if="!stoneDetail.bloc_3d"
                  class="btn"
                  @click="new_3d_is_visible = !new_3d_is_visible"
                >
                  <i class="icon icon-cloud-upload"></i>
                </button>
                <button
                  v-else
                  class="btn"
                  @click="delete_3d_is_visible = !delete_3d_is_visible"
                >
                  <i class="icon icon-delete-outlined"></i>
                </button>
              </div>
            </h5>
            <div v-for="(info, i) in dataStoneLocale.data_3d.list" :key="i">
              <strong>{{info.label}}:</strong>
              <span class="ml-3">
                {{stoneDetail.bloc_3d ? stoneDetail.bloc_3d[info.entity] : '--'}}
              </span>
            </div>
          </section>
          <footer class="col-12 d-flex justify-content-between aligne-items-center text-right" :key="key_iframe">

          <SharingList 
            :network_list="share_info.share_list"
            :titel="share_info.title"
            :description="share_info.description"
            :url="share_info.url"
          />
            <span class="ml-3">
              {{is_pt_br ? 'Cadastrado em ' : "Created at " }}{{ stoneDetail.created_at | formatDateGlobal }}
            </span>
          </footer>
          <div class="col-12">

          </div>
        </div>
      </div>
    </div>
    <h4 class="text-truncate w-100">{{dataStoneLocale.title_3d}}:</h4>
    <div class="iframe-container mb-5">
      <iframe
        class="content"
        style="border: none; border-radius: 8px"
        title="Visão 3D do bloco"
        :src="url_iframe"
      />
    </div>
    <h4>{{dataStoneLocale.title_video}}:</h4>

    <div class="iframe-container mb-5">
      <iframe
        class="content"
        style="border: none; border-radius: 8px"
        title="Vídeo do bloco"
        :src="url_iframe_video"
      />
    </div>
  </div>
</template>

<script>
import BoxImage from "../../components/utils/BoxImage.vue";
import New3D from "../../components/stone/New3D.vue";
import Delete3D from "../../components/stone/Delete3D.vue";
import DeleteStone from "../../components/stone/DeleteStone.vue";
import DeleteImg3D from "../../components/stone/DeleteImg3D.vue";
import EditeStone from "../../components/stone/EditeStoneData.vue";
import CarrocelImage from "../../components/utils/CarrocelImage.vue";
import SharingList from "../../components/utils/SharigList.vue";

import { mapActions, mapGetters } from "vuex";

export default {
  name: "StoneDetail",
  props: ['id'],
components: {
    BoxImage,
    New3D,
    Delete3D,
    DeleteStone,
    DeleteImg3D,
    EditeStone,
    CarrocelImage,
    SharingList
  },
  data() {
    return {
      new_3d_is_visible: false,
      delete_3d_is_visible: false,
      delete_img_is_visible: false,
      delete_stone_is_visible: false,
      edit_stone_visible: false,
      key_iframe: 0,
      key_page: 0,
    };
  },
  metaInfo() {
    return {
      title: `Bloco (N° ${this.stoneDetail ? this.stoneDetail.bloc_number : 0}) - ${this.stoneDetail ? this.stoneDetail.name_material : '-'}`,
      meta: [
          { name: 'description', content: this.mountDimencionsLabel(this.stoneDetail)},
          { property: 'og:title', content: `Bloco (N° ${this.stoneDetail ? this.stoneDetail.bloc_number : 0}) - ${this.stoneDetail ? this.stoneDetail.name_material : '-'}`},
          { property: 'og:site_name', content: 'Stonebox'},
          { property: 'og:description', content: this.mountDimencionsLabel(this.stoneDetail)},
          { property: 'og:type', content: 'profile'},
          { property: 'og:url', content: window.location.origin + this.$route.path},
          { property: 'og:image', content: `https://stonebox.app.br/images/1630681146546-stone_176-54.jpg`  }    
          // { property: 'og:image', content: `${process.env.VUE_APP_API_BASE_URL}/image/stone/${this.id}`  }    
      ]
    }
  },
  computed: {
    ...mapGetters("stone", ["stoneDetail", "dataStoneLocale"]),
    ...mapGetters("user", ["isAdmin", 'companyId']),
    is_pt_br(){
      return this.$store.getters.is_pt_br
    },

    isAdmin2Stone(){
      return this.isAdmin && this.companyId === this.stoneDetail.company_id
    },
    share_info(){
      return {
         share_list: ['telegram','whatsapp', 'email','facebook',],
         title: `Bloco (n° ${ this.stoneDetail.bloc_number }) ${ this.stoneDetail.name_material }`,
         description: this.mountDimencionsLabel(this.stoneDetail),
         url: window.location.origin + this.$route.path
      }
    },
    url_iframe() {
      return `${process.env.VUE_APP_API_BASE_URL}/3d/${this.stoneDetail.id}`;
    },
    url_iframe_video() {
      return `${process.env.VUE_APP_API_BASE_URL}/video_player/${this.stoneDetail.id}`;
    },
  },

  async created() {
    await this.setStoneDetail(this.id).then()
    .catch( error => 
        this.$router.push({
          name: "Exception",
          params: { mode: "block-not-fond" },
        })
        );

  },

  methods: {
    ...mapActions("stone", ["setStoneDetail"]),
    ...mapActions("alertes", ["alertSuccess", "alertDanger"]),
    mountDimencionsLabel(data){
      let src = ''
      if(data){
        src += `Bloco (n° ${ this.stoneDetail.bloc_number }) ${ this.stoneDetail.name_material }\n`
        src += `Tipo: ${data.type} \n` 
        src += `Altura: ${data.height.toFixed(2)}m |\t`  
        src += `Largura: ${data.width.toFixed(2)}m \n`
        src += `Comprimento: ${data.diameter.toFixed(2)}m |\t`
        src += `Peso: ${data.weight.toFixed(2)}Ton`
        return src
      }
    else 'Sem dados'
    },
    async handleDelete3D(error) {
      this.delete_3d_is_visible = !this.delete_3d_is_visible;
      this.key_iframe++;
      await this.setStoneDetail(this.id);
      this.showAlert(error, "excluír 3D", "3D do bloco excluído com sucesso");
    },

    async handleCreate3D(error) {
      await this.setStoneDetail(this.id);
      this.key_iframe++;
      this.showAlert(
        error,
        "create block 3D",
        this.is_pt_br ? "3D do bloco criado com sucesso" : "3D of successfully created block" 
      );
    },

    backPage() {
      this.$router.push({ name: "StoneList" });
    },
    handleDeleteImg(error) {
      this.delete_img_is_visible = false;
      this.showAlert(
        error,
        "reemove block images",
        this.is_pt_br ? "Imagens excluído com sucesso" : "Images deleted successfully"
      );
    },

    handleEdite(error) {
      this.showAlert(error, 
      "edit block", 
      this.is_pt_br ?  "Bloco editado com sucesso": 'Block edited successfully');
    },

    showAlert(error, action, success) {
      if (!error) {
        this.alertSuccess(success);
        this.$router.push({ name: "StoneList" });
      } else {
        this.alertDanger(`Algo deu errado em ${action}: `, error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.iframe-container {
  overflow: hidden;
  /* 16:9 aspect ratio */
  padding-top: 56.25%;
  position: relative;
}

.iframe-container .content {
  border: 0;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.icon {
  height: 22px;
  width: 22px;
}

.icon-delete-outlined {
  background: #c82333;
}

.title {
  width: 200px;
}
.truncate {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (max-width: 400px) {
  .iframe-container {
    height: 400px;
  }

  .iframe-container iframe {
    border: 0;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 280px;
  }
}
</style>
